/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import ThankYou from "./ThankYou";

export default ThankYou;
